
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'
import { isNull } from 'lodash'
import iconPrev from './icon-prev.svg'
import iconNext from './icon-next.svg'
import { isArrayWithLength } from '~/ZenOne-StoryBook/helpers/types'

export default {
  name: 'Carousel',
  components: {
    Slick,
  },
  props: {
    isCatalog: {
      type: Boolean,
      default: true,
    },
    isInfinite: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    viewportWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isPrevBtnDisabled: !this.isInfinite,
      isNextBtnDisabled: false,
      currentIndex: 0,
      slideComponent: null,
      slickOptions: this.getSlickOptions(),
      iconPrev,
      iconNext,
    }
  },
  computed: {
    showCarousel() {
      return !isNull(this.slideComponent)
    },
    itemsCount() {
      const { items = [] } = this
      return isArrayWithLength(items) ? items.length : 0
    },
    showCarouselContent() {
      return isArrayWithLength(this.items)
    },
    getWrapperClass() {
      const { viewportWidth = 0, items = [] } = this
      const itemsCount = isArrayWithLength(items) ? items.length : 0
      if (!itemsCount) return null
      if (
        (viewportWidth < 1680 && itemsCount <= 3) ||
        (viewportWidth < 2223 && itemsCount <= 4) ||
        (viewportWidth >= 2223 && itemsCount <= 5)
      ) {
        return 'slick-is-off'
      }

      return null
    },
    showNav() {
      return isNull(this.getWrapperClass)
    },
  },
  async mounted() {
    const module = this.isCatalog
      ? await import('~/components/Catalog/ProductCard')
      : await import(
          '~/components/Catalog/ProductCardDetail/Alternatives/AlternativeCard'
        )
    this.slideComponent = module.default
  },
  methods: {
    getSlickOptions() {
      const { isCatalog = false } = this
      const options = {
        slidesToShow: isCatalog ? 5 : 4,
        slidesToScroll: isCatalog ? 5 : 4,
        arrows: false,
        infinite: this.isInfinite,
      }
      options.responsive = isCatalog
        ? [
            {
              breakpoint: 1680,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 2223,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              },
            },
          ]
        : [
            {
              breakpoint: 1680,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
          ]
      return options
    },
    setArrowsDisabling() {
      if (this.isInfinite) return false
      if (this.currentIndex === 0) {
        this.isPrevBtnDisabled = true
        this.isNextBtnDisabled = false
      } else {
        this.isPrevBtnDisabled = false
        const carousel = this?.$refs?.carousel ?? {}
        const activeSlides = carousel?.$el?.querySelectorAll('.slick-active')
        const slidesToShow = activeSlides?.length ?? 0
        if (slidesToShow < 1) return false
        this.isNextBtnDisabled =
          this.currentIndex >= this.itemsCount - slidesToShow
      }
    },
    handleReInit() {
      this.$nextTick(() => {
        const carousel = this?.$refs?.carousel ?? null
        if (!carousel) return false
        carousel.reSlick()
      })
    },
    handleAfterChange(event, slick, currentSlide) {
      this.currentIndex = currentSlide
      this.setArrowsDisabling()
    },
    prevButtonClickHandler() {
      const carousel = this?.$refs?.carousel ?? null
      if (carousel) {
        carousel.prev()
      }
      return false
    },
    nextButtonClickHandler() {
      const carousel = this?.$refs?.carousel ?? null
      if (carousel) {
        carousel.next()
      }
      return false
    },
    onAddProductToCart(data = {}) {
      this.$emit('onAddProductToCart', data)
    },
    onChangeQtyInCart(data = {}) {
      this.$emit('onChangeQtyInCart', data)
    },
    updateCartHandler(data = {}) {
      this.$emit('updateCartHandler', data)
    },
    onSort(v) {
      this.$emit('onSort', v)
    },
    productCardFilterClickHandler(data) {
      this.$emit('productCardFilterClickHandler', data)
    },
    onShowAddToInventoryDialog(data = {}) {
      this.$emit('on-show-add-to-inventory-dialog', data)
    },
    onAddToRootFolder(data = {}) {
      this.$emit('on-add-to-root-folder', data)
    },
  },
}
